export default __webpack_public_path__ + "static/media/1-sgi-ingreso-v1.f3ad6c8b.png";